/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcMailRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4 3.1A2.9 2.9 0 0 0 1.1 6v12A2.9 2.9 0 0 0 4 20.9h16a2.9 2.9 0 0 0 2.9-2.9V6A2.9 2.9 0 0 0 20 3.1zm-.192 1.817Q3.9 4.9 4 4.9h16q.099 0 .191.017l-8.124 7.312a.1.1 0 0 1-.134 0zM2.9 6.52V18A1.1 1.1 0 0 0 4 19.1h16a1.1 1.1 0 0 0 1.1-1.1V6.52l-7.83 7.046a1.9 1.9 0 0 1-2.541 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}
export default IcMailRegular;
